









import Vue from 'vue'
export default Vue.extend({
    props: {
        //  The color of the button
        color: {
            type: String,
            default: 'grey darken-2'
        },
        //  The icon displayed to the left of the title
        icon: {
            type: String,
            default: 'mdi-domain'
        },
        //  Applies the 'large' prop to the button
        large: {
            type: Boolean,
            default: false
        },
        //  Applies the 'small' prop to the button
        small: {
            type: Boolean,
            default: false
        },
        //  The text shown on the button
        title: {
            type: String,
            default: 'Add Workspace'
        },
        //  Set the 'width' prop on the button
        width: {
            type: [String, Number],
            default: null
        }
    },
    methods: {
        tenantAdd(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: 'New Workspace',
                icon: 'mdi-domain',
                color: 'primary',
                component: 'tenant-create-form'
            })
        }
    }
})
